<template>
  <CheckoutHeader />
  <slot />
  <CheckoutFooter/>
</template>

<script setup>
  
</script>